/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var gettext = require('mag-gettext').gettext;

function saveValue ( value ) {
    var randomNumber = Math.floor(15360000 / 20000 * value);

    gSTB.SetBufferSize(value, randomNumber); //eslint-disable-line
}

module.exports = function ( app ) {
    return {
        id: 'bufferSize',
        name: gettext('Buffer size'),
        description: gettext('Increasing of the buffer size allows you to view a video without delay, if the Internet speed is slow or unstable.'),
        icon: 'theme-icon-play',
        data: {
            bufferSize: 0
        },
        config: {
            min: 0,
            max: 20000,
            step: 100
        },
        saveImmediate: true,
        prepareForRender: function ( env, callback ) {
            this.data.bufferSize = +env.bufferSize;

            callback(env.bufferSize);
        },
        prepareForSave: function ( value, callback ) {
            this.data.bufferSize = value;

            saveValue(value);
            callback();
        },
        render: app.api.renders.rangeInput,
        parent: 'playback'
    };
};

module.exports.setValue = saveValue;
